import styled, { css } from 'styled-components';

import {
  DEFAULT_DESKTOP_HEADER_HEIGHT,
  DEFAULT_MOBILE_HEADER_HEIGHT,
} from '@/theme/dimensions';

import { Box } from './Box';

export const HEADER_OFFSET_VAR = '--header-offset';

const getMarginTop = (
  defaultHeight: number,
  headerHeight?: number,
  useHeaderOffset?: boolean,
) => {
  if (headerHeight != null && headerHeight !== 0) {
    return `${Math.max(headerHeight - 1, defaultHeight)}px`;
  }

  return useHeaderOffset
    ? `max(var(${HEADER_OFFSET_VAR}, ${defaultHeight}px), ${defaultHeight}px)`
    : `${defaultHeight}px`;
};

export const MainBox = styled(Box)<{
  $headerHeight?: number;
  $useHeaderOffset?: boolean;
}>`
  flex: 1;
  display: block !important;
  margin-top: ${({ $headerHeight, $useHeaderOffset }) =>
    getMarginTop(
      DEFAULT_MOBILE_HEADER_HEIGHT,
      $headerHeight,
      $useHeaderOffset,
    )};

  ${({ $headerHeight, $useHeaderOffset, theme }) =>
    css`
      ${theme.media.md.up} {
        margin-top: ${getMarginTop(
          DEFAULT_DESKTOP_HEADER_HEIGHT,
          $headerHeight,
          $useHeaderOffset,
        )};
      }
    `}
`;
